// 土耳其----address
module.exports = {
  validate: {
    noEmail: "E-posta boş olamaz, lütfen tekrar giriniz",
    noPhone: "Telefon numarası boş geçilemez, lütfen tekrar giriniz",
    errorReg:
      "Giriş uzunluğu 1-50 hanedir, büyük ve küçük harfler, sayılar, semboller - ._ @ girebilirsiniz",
    noPassword: "Şifre boş olamaz, lütfen tekrar giriniz",
    pwdReg:
      "Şifre giriş uzunluğu sadece 8-32 hanedir ve rakam ve harflerden oluşmalıdır",
    pwdCheck: "Girilen iki şifre tutarsız, lütfen tekrar giriniz",
    pwdLengthReg:
      "Parola uzunluğu 8 ile 32 arasında değişiyor, lütfen girişi onaylayın",
    noCode: "lütfen doğrulama kodunu girin",
    codeReg: "Lütfen 6 haneli bir doğrulama kodu giriniz",
    nullText: "Giriş boş olamaz, lütfen tekrar giriniz",
    phoneCheck:
      "İki defa girilen telefon numarası tutarsız, lütfen tekrar giriniz",
    emailNumReg:
      "E-posta giriş uzunluğu 6-50 karakterdir, lütfen tekrar giriniz",
    emailReg: "Yanlış e-posta adresi, lütfen tekrar giriniz",
    emailCheck: "İki kez girilen e-posta hesabı tutarsız, lütfen tekrar girin",
    noUsername: "Şifre, hesap numarasını içeremez, lütfen tekrar giriniz",
    accountReg: "Hesap adı girişi yanlış, lütfen tekrar giriniz",
  },
  area: {
    areaTitle: "Alan Yönetimi",
    add: "Alan ekle",
    area: "alan",
    addNextArea: "Yeni bir alt alan oluştur",
    areaNameTip: "Lütfen bir bölge adı giriniz",
    areaNameHold: "Giriş uzunluğu 1-20 hanedir, özel sembol girilemez",
    areaNumHold:
      "Giriş uzunluğu 1-4 hanedir, sadece rakamlar girilebilir ve sayı aralığı 0-9999'dur",
    areaNumTip: "Lütfen bölge numarasını giriniz",
    areaName: "Alan adı",
    checkAreaName: "Alan adı boş geçilemez, lütfen tekrar giriniz",
    areaNameTip1: "Alan adı boş geçilemez",
    areaNameTip2: "Yanlış alan adı girişi, lütfen tekrar giriniz",
    areaNum: "Alan Numarası",
    checkAreaNum: "Alan kimliği boş olamaz, lütfen tekrar giriniz",
    lastLevel: "Üstün alana aittir",
    checkLastLevel:
      "Ait olduğu üst düzey alan boş olamaz, lütfen tekrar seçiniz",
    lastLevelTip: "Lütfen ait olduğunuz ana alanı seçin",
    delInfo:
      "Bu silme görevini yürütmek, bu alandaki verileri siler ve kurtarılamaz",
    oneStep: "Seviye bir",
    twoStep: "ikincil",
    threeStep: "3. seviye",
    fourStep: "Seviye 4",
    fiveStep: "Seviye 5",
    delAreaTip: "Silinen bir alt alan var",
    personArea: "Kişi alana bağlı değildir",
    areaType: "Yöntem ekle",
    addArea1: "Ayrı ekle",
    addArea2: "sürekli ekleme",
    addArea3: "Matris toplama",
    areaNameTop: "Bölge Adı Öneki",
    areaNameLast: "Bölge Adı Soneki",
    areaJoinHold: "Lütfen alan adı önekini giriniz",
    areaJoinHold1: "Lütfen alan adı son ekini giriniz",
    startNum: "Başlangıç numarası",
    checkStartNum: "Başlangıçtaki numara girişi yanlış, lütfen tekrar giriniz",
    checkStartNum1:
      "Başlangıç numarası girişi boş olamaz, lütfen tekrar giriniz",
    checkEndNum: "Bitiş numarası girişi yanlış, lütfen tekrar giriniz",
    checkEndNum1: "Bitiş numarası boş geçilemez, lütfen tekrar giriniz",
    endNum: "Bitiş numarası",
    topStart: "Başlık başlangıç numarası",
    checkTopStart:
      "İlk başlangıç numarasının girişi yanlış, lütfen tekrar giriniz",
    checkTopStart1:
      "İlk başlangıç numarası girişi boş olamaz, lütfen tekrar giriniz",
    topEnd: "Başlık bitiş numarası",
    checkTopEnd:
      "Başlığın bitiş numarasını giriniz yanlış, lütfen tekrar giriniz",
    checkTopEnd1: "Birinci son sayı girişi boş olamaz, lütfen tekrar giriniz",
    lastStart: "Kuyruk başlangıç numarası",
    checkLastStart:
      "Kuyruk başlangıç numarası girişi yanlış, lütfen tekrar giriniz",
    checkLastStart1:
      "Kuyruk başlangıç numarasını giriniz boş olamaz, lütfen tekrar giriniz",
    lastEnd: "Yol Bitiş Numarası",
    checkLastEnd:
      "Kuyruğun bitiş numarasını giriniz yanlış, lütfen tekrar giriniz",
    checkLastEnd1: "Son numara girişi boş olamaz, lütfen tekrar giriniz",
    topTip:
      "Giriş uzunluğu 1-2 hanedir, sadece rakamlar girilebilir ve sayı aralığı 1-99'tür",
    lastTip:
      "Giriş uzunluğu 1-2 hanedir, sadece rakamlar girilebilir ve sayı aralığı 1-99'dir",
    areaNameTest: "Alan adı örneği",
  },
  addressBook: {
    config: "Proje konfigürasyonu",
    errorTip: "Adres defteri biçim hatası",
    upgrade: "Adres Defteri Yükseltme Yönetimi",
    deviceIdTip: "Lütfen cihaz kimliğini giriniz",
    deviceId: "Cihaz Kimliği",
    syncAll: "Tümünü senkronize et",
    sync: "Senkronize et",
    sysVersion: "Mevcut Sistem Adres Defteri Sürümü",
    deviceVersion: "Mevcut cihaz adres defteri sürümü",
    syncTip: "Senkronize komut başarıyla verildi",
  },
  newarea: {
    add: "Alan ekle",
    edit: "Alanı Düzenle",
    smallTip: "Şu anda en küçük alan seviyesi, başka alt alan eklenemez",
    batch: "Toplu ekleme alanı",
    batch1: "sürekli ekleme",
    batch2: "Matris toplama",
  },
  deviceSip: {
    saveTip:
      "Lütfen adres defterini zamanında dışa aktarın, aksi takdirde sayfadan çıktıktan sonra tüm veriler silinecektir.",
    devMsg: "Cihaz bilgisi",
    list: "Aygıt listesi",
    add: "Cihaz ekle",
    edit: "Cihaz Düzenle",
    batch: "Cihazları toplu olarak ekle",
    areaChosen: "Alan seviyesi seçimi",
    areaNum: "Her alandaki yeni eklenen cihaz sayısı",
    bacthTip:
      "Alan seviyesi bina olarak seçildiğinde ve her alandaki yeni cihaz sayısı 4 ise oluşturulan her alana 4 cihaz ekleniyor demektir",
    note: "gözünde canlandırmak",
    baseConfig: "Temel Bilgi Yapılandırması",
    deviceName: "Cihaz adı",
    nameTip:
      "Ait olduğu grubun adına bir sayı eklenmesi düzeltildi, örneğin Bina 1-1",
    function: "Cihaz destek işlevi",
    net: "Ağ Yapılandırması",
    netType: "Ağ tipi",
    netTip1:
      "Statik, statik bir ağdır, IP'yi ve diğer bilgileri manuel olarak ayarlamanız gerekir.",
    netTip2:
      "DHCP dinamik bir ağdır ve IP gibi bilgiler yönlendirici tarafından otomatik olarak atanır.",
    mask: "Lütfen alt ağ maskesini girin",
    gateway: "Lütfen ağ geçidini girin",
    ip: "Lütfen IP adresini giriniz",
    ipTip:
      "Giriş IP adresinin 127.0.0.1 vb. gibi özel IP'den kaçınması gerekiyor.",
    dns1: "Lütfen DNS1'i girin",
    dns2: "Lütfen DNS2'yi girin",
    sip1: "sip1 bilgi yapılandırması",
    config: "Bilgi Yapılandırması",
    mode: "model",
    mode1: "Doğrudan Mod",
    mode2: "Sunucu Modu",
    user: "lütfen kullanıcı adını giriniz",
    userTitle: "Kullanıcı adı",
    userTip: "Varsayılan, grup adına 1-1-1 gibi bir sayı eklemektir",
    last: "Lütfen hesap son ekini giriniz",
    sipTip:
      "Lütfen SIP sunucusunun kayıtlı kullanıcı adını ve şifresini giriniz",
    password: "Şifrenizi giriniz Lütfen",
    passwordTitle: "şifre",
    serverIp: "Lütfen sunucu IP'sini girin",
    protocolType: "Lütfen protokol tipini seçiniz",
    protocolTypeTitle: "sözleşme türü",
    sip2: "sip2 bilgi yapılandırması",
    more: "Daha fazla",
    close: "kapatma",
    formatError: "Format hatası, lütfen tekrar giriniz",
    forbidTip: "127.0.0.1'e girmek yasak, lütfen tekrar girin",
    call: "Ara ve ara",
    monitor: "izleme",
    lift: "Asansör Kontrolü",
    rtsp: "rtsp video akışı",
    deviceTip: "Cihaz destek fonksiyonu boş bırakılamaz, lütfen tekrar seçiniz",
    maskTip1: "Alt ağ maskesi boş olamaz, lütfen tekrar giriniz",
    maskTip2: "Alt ağ maskesinin biçimi yanlış, lütfen yeniden girin",
    gatewayTip1: "Gateway boş olamaz, lütfen tekrar giriniz",
    gatewayTip2: "Gateway format hatası, lütfen tekrar giriniz",
    ipTip1: "IP adresi boş olamaz, lütfen tekrar giriniz",
    ipTip2:
      "IP adresi format hatası, üst sınır 255.254.254.253, ilk paragraf 0 değil, lütfen tekrar giriniz",
    dns1Tip1: "DNS1 boş olamaz, lütfen tekrar giriniz",
    dns1Tip2: "DNS1 biçim hatası, lütfen tekrar girin",
    dns2Tip1: "DNS2 format hatası, lütfen tekrar girin",
    passwordTip1: "Şifre boş olamaz, lütfen tekrar giriniz",
    serviceTip1: "serviceIp boş olamaz, lütfen tekrar girin",
    serviceTip2: "serviceIp biçim hatası, lütfen tekrar girin",
    sip2Tip:
      "Şu anda sip2 bilgilerini yapılandırdınız, lütfen kurallara göre tamamlayın",
    devnameTip1: "Cihaz adı boş olamaz, lütfen tekrar giriniz",
    devnameTip2: "Cihaz adı biçim hatası, lütfen tekrar girin",
    nameTip1: "Kullanıcı adı boş geçilemez, lütfen tekrar seçiniz",
    nameTip2: "Kullanıcı adı boş geçilemez, lütfen tekrar seçiniz",
    maxTip1:
      "Geçerli alandaki cihaz sayısı üst sınır olan 8'e ulaştı ve daha fazla eklenemez",
    area: "alan",
    editArea: "Alanı Düzenle",
    addArea: "Alan ekle",
    batchArea: "Toplu ekleme alanı",
    deleteArea: "Bölgeyi Sil",
    areaName: "Alan adı",
    areaNo: "Alan Numarası",
    importAddr: "Adres Defterini İçe Aktar",
    next: "Sonraki adım",
    areaTip1: "Lütfen önce düzenlenecek alanı seçiniz",
    areaTip2: "Lütfen önce silinecek alanı seçiniz",
    areaTip3:
      "Mevcut alanınız boş, şu anda toplu olarak cihaz ekleyemezsiniz, lütfen önce alan bilgilerini ekleyin",
    noArea: "Henüz bölge yapılandırması yok",
    error: "Veri istisnası",
    addDevice: "Cihaz ekle",
    editDevice: "Cihaz Düzenle",
    delDevice: "Cihazı sil",
    batchDevice: "Cihazları toplu olarak ekle",
    prev: "Öncesi",
    updateAddr: "Cihaz Adres Defterini Güncelle",
    saveAddr: "Adres Defterini Kaydet",
    exportAddr: "Adres Defterini Dışa Aktar",
    deleteTip: "Cihazın silinip silinmeyeceği",
    deleteTip2:
      "Şu anda bölge olarak seçili, lütfen silmek için bölge yapılandırmasına dönün",
    deleteTip3: "Lütfen önce silinecek cihazı seçin",
    deviceTip1: "Lütfen önce düzenlenecek cihazı seçiniz",
    deviceTip2: "Lütfen önce bölgeyi seçin, ardından cihazı ekleyin",
    exportSuccess: "Dışa aktarma başarılı",
    xmlTip: "Lütfen adres defterinin xml dosyasını yükleyin",
    xmlTip1: "Lütfen yüklenecek xml dosyasını seçin",
    xmlTip2:
      "İçe aktarılan adres defteri, mevcut topluluk düzeyiyle tutarsız ve içe aktarma başarısız oldu",
    areaConfig: "Alan Yapılandırması",
    deviceConfig: "Cihaz konfigürasyonu",
    exportConfig: "Önizleme Dışa Aktarma",
    projectConfig: "Proje Konfigürasyonu",
    prevArea: "Üstün alana aittir",
    areaNoTip:
      "Başlangıç numarası bitiş sayısından büyük lütfen tekrar doldurunuz",
    smallAreaTip: "Şu anda en küçük alan seviyesi, başka alt alan eklenemez",
    areaNoTip1:
      "Birinci bölümün başlangıç numarası, ilk bölümün bitiş sayısından büyük, lütfen tekrar doldurunuz",
    areaNoTip2:
      "Kuyruğun başlangıç numarası, kuyruğun bitiş sayısından büyük, lütfen tekrar doldurun",
  },
  push: {
    list: "Kayıt Bas",
    productType: "Ürün numarası",
    softwareName: "yazılımın adı",
    versionNo: "versiyon numarası",
    time: "İtme Zamanı",
    invalidTime: "Son kullanma süresi ",
    upgrade: "güncelleme",
    upgradeRecord: "Yükseltme Kaydını Görüntüle",
    deviceType: "Ekipman Türü",
    deviceName: "Cihaz adı",
    currentSoftName: "Geçerli cihaz yazılımı adı",
    currentSoftNo: "Mevcut cihaz sürüm numarası",
    upgradeNo: "Yükseltme yazılımı sürüm numarası",
    filterTip1: "Lütfen cihaz adını giriniz",
    filterTip2: "Lütfen yazılım adını seçin",
    filterTip3: "Lütfen bir sürüm numarası seçin",
    checkTip: "İşareti Etkinleştir",
    ota: "OTA yükseltmesi",
    taskName: "görev adı",
    taskNameTip: "Lütfen bir görev adı giriniz",
    binName: "Bellenim Adı",
    upgradeType: "Görev yükseltme yöntemi",
    done: "Hemen yürütülüp yürütülmeyeceği",
    upgradeTime: "yükseltme zamanı",
  },
  check: {
    submit: "Tebrikler, gönderim başarılı!",
    noSubmit: "Hata, gönderim başarısız oldu!",
    file: "Bir belge seçin",
    noFile: "Dosya seçilmedi",
    projectName: "proje Adı",
    projectNameTip: "Lütfen bir proje adı giriniz",
    describe: "betimlemek",
    contentTip: "Lütfen içeriği giriniz",
    areaType: "Bölge Hiyerarşisi",
    example: "Örneğin: bina-birim-oda numarası",
    areaTip: "Alan numarası formatı yanlış, lütfen tekrar giriniz",
    areaNameTip: "Lütfen bir katman adı girin",
    nameTip: "İsim boş bırakılamaz, lütfen tekrar giriniz",
    nameError: "Ad yanlış girildi, lütfen tekrar giriniz",
    nameLength: "Ad giriş uzunluğu 4~50, lütfen tekrar girin",
    areaNullTip: "Alan seviyesi boş olamaz",
    formateError: "Uzunluk 1-6 hanedir, özel sembol girilemez",
    noAreaTip: "Alan seviyesi boş olamaz, lütfen tekrar seçiniz",
    maxFileTip: "Dosya boyutu sınırı aşıyor",
    xmlTip: "Lütfen XML formatında bir dosya yükleyin",
  },
  book: {
    areaBy: "Bölge",
    list: "Cihaz Bilgileri Kopya Listesi",
    repeatTip:
      "Aşağıdaki ekipman bilgileri yineleniyor. Lütfen çoğaltılan ekipman bilgilerini değiştirin.  Onayla yı tıkladıktan sonra,  ekipman giriş bilgilerinin yinelenmesini değerlendirecektir. ",
    coverTip:
      "Bu işlem, seçili olan düzeyin toplu ekleme verilerinin üzerine yazacaktır",
    batchTip: "Cihazları toplu olarak ekleyerek oluşturulan IP aralığı",
  },
  updateNewSip: {
    otaDeleteTip:
      "Silme başarısız, yalnızca başlatılmamış görevler silinebilir",
    deleteArea1: "Bölgenin silinip silinmeyeceği",
    deleteArea2:
      "Aynı zamanda bu alanın altındaki tüm alanlar ve cihazlar birlikte silinecektir",
    codeRepeatTip:
      "Aynı seviyedeki bölge kimliği tekrar edilemez, lütfen mevcut bölge kimliğini tekrar girin",
    nameRepeatTip:
      "Aynı seviyedeki alan adları kopyalanamaz, lütfen geçerli bölge adını tekrar girin",
    deviceIp: "Cihaz IP'si",
    callin: "Giriş",
    callout: "nefes ver",
    systemMsg: "sistem bilgisi",
    batchIpTip:
      "Cihazları bu sefer toplu olarak ekleyerek oluşturulan IP aralığı",
    ip: "IP adresi",
    mask: "Alt Ağ Maskesi",
    gateway: "Geçit",
    noData: "HAYIR",
    noAddressTip:
      "Şu anda senkronize edilebilecek bir adres defteri verisi yok",
    operator: "Şebeke",
    goTip: "İlgili adıma atlamak için tıklayın",
    deviceNameTip: "Giriş uzunluğu 1-16 hanedir, özel sembol girilemez",
    filter1: "Filtrelemek için bir alan adı girin",
    filter2: "Filtrelemek için alan adını veya cihaz adını girin",
    secret: "Şifreleme Şifresi",
    secretTip:
      "Lütfen 32 karakterlik bir şifre giriniz, format sınırlaması yoktur",
    noSecretTip: "Şifreleme şifresi ayarlanmamışsa göz ardı edilebilir",
    setSecret: "Adres defteri şifreleme parolasını ayarla",
    ignore: "ihmal etmek",
    emptyBookTip: "Adres defteri boş ve geçici olarak dışa aktarılamaz",
    errorSecret: "Adres defteri şifreleme şifre hatası, lütfen tekrar giriniz",
    other: "diğer",
    doorAuth: "Giriş kontrolu",
    funTitle: "Lütfen eklediğiniz cihazın desteklediği işlevleri kontrol edin",
    callInTip: "Cihaz Destek Çağrısı",
    callOutTip: "Cihaz desteği aranır",
    monitorTip: "Cihaz izlenmeyi destekliyor",
    doorTip: "Cihaz kilit açma işlevini destekliyor",
    liftTip: "Cihaz destek kontrol asansörü",
    maskTip: "Lütfen alt ağ maskesini girin, biçim referansı: 255.255.255.255",
    gatewayTip: "Lütfen ağ geçidini girin, biçim referansı: 1.1.1.1",
    ip1: "Lütfen IP adresini girin, biçim referansı: 1.1.1.1",
    ipTip:
      "Giriş IP adresinin 127.0.0.1 vb. gibi özel IP'den kaçınması gerekiyor.",
    dns1: "Lütfen DNS1'i girin, biçim referansı: 1.1.1.1",
    dns2: "Lütfen DNS2'yi girin, biçim referansı: 1.1.1.1",
    serverIp:
      "Lütfen serverIp, biçim referansı: 1.1.1.1 veya etki alanı adını girin",
    successxml: "Dosya başarıyla ayrıştırıldı",
    groupCall: "grup araması",
    groupCallTip:
      "Açıldıktan sonra grup arama simgesine tıklayarak gruptaki tüm cihazları arayabilirsiniz",
    record: "sürüm kaydı",
    export: "ihracat",
    sync: "Senkronize et",
    communityTip:
      "Şu anda alan cihaz verileri var, alan seviyesinin değiştirilmesi yasak",
    areaNameTitle: "Hiyerarşi Tanımı",
    noDataTip: "Şu anda veri yok",
    areaCodeDescriptionTip: "Bölge tasvir boş olamaz. Lütfen tamamen doldur.",
    moduleName: "Adres Kitabı Yapılandırma Aracı",
    userSipAccount:
      "Aile grup+ekipman numarasının alan sayısı olarak ayarlanmış",
    devMax: "Aygıt düğümü 10000 giriş sınırını aştı, eklenemedi",
    areaMax: "Alan düğümü 10000 giriş sınırını aştı, eklenemedi",
    ipAndMaskTip1:
      "IP adresi alt ağ maskesiyle ilişkilidir ve iş mantığı doğrulamasının, bitişik AND işleminden sonra tüm 1'ler veya tüm 0'larla sonuçlanması gerekmektedir.",
    ipAndMaskTip2:
      "Bir iş doğrulama kuralı hatası oluştuğunda, ilgili IP adresini değiştirin.",
    ipAndMaskTip3:
      "Alt ağ maskesi ve IP adresinin iş doğrulama kuralları yanlış. Lütfen IP adresini değiştirin.",
    ipAndMaskTip4:
      "Cihazları toplu olarak eklerken, iş mantığı doğrulamasını karşılamayan IP'ler otomatik olarak atlanacaktır.",
    correctMaskTip: "Lütfen önce doğru alt ağ maskesini doldurun.",
    correctIpTip: "Lütfen doğru IP adresini girin.",
  },
  newDeviceType: {
    indoorMachine: "İç birim",
    doorPhone: "Kapı telefonu",
    smallDoor: "Küçük kapı telefonu",
    manage: "Yönetim cihazı",
    wall: "Duvar cihazı",
    monitor: "IP kameri",
    unitGuard: "Bölüm yönetim cihazı",
    networkCard: "Ağ kart okuyucusu",
    unitCard: "Bölüm kart okuyucusu",
    lift: "Asansör entegrasyon modülü",
    deviceTypeTip: "Lütfen cihaz tipini seçin"
    }
};
